import { IoIosMore } from "react-icons/io";
import FormatePrice from '../../utils/FormatePrice';
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { fetchTransactions } from "../../redux/slices/transactionSlice";
import 'react-responsive-pagination/themes/classic.css';
import ResponsivePagination from 'react-responsive-pagination';
import Loader from "../Loader";
import { TransactionStatus } from "../../utils/Enums";
import { formatDateTime, FormateDate } from "../../utils/FormateDate";

const TransactionsTable = ({ onRowClick, data, itemsPerPage, currentPage, setCurrentPage, isLoading, totalRecord }) => {
  const dispatch = useDispatch();
  const totalPages = Math.ceil(totalRecord / itemsPerPage);

  useEffect(() =>{
      dispatch(fetchTransactions())
  }, [dispatch]);
 

  return (
    <div className="flow-root bg-white">
        <div className="overflow-x-auto rounded-tr-lg rounded-tl-lg">
          <div className="inline-block min-w-full align-middle">
            <table className="min-w-full divide-y divide-gray-300 table-auto p-4 border">
              <thead className="bg-primaryGray p-1 rounded-t-md rounded-tr-md">
                <tr>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-black">
                    S/N
                  </th>
                  <th scope="col" className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold capitalize text-black">
                  Transaction ID
                  </th>
                  <th scope="col" className="py-3.5 text-center text-sm font-semibold capitalize text-black">
                  Date
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold capitalize text-black">
                  type
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold capitalize text-black">
                    amount
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold capitalize text-black">
                    balance
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold capitalize text-black">
                    Status
                  </th>
                  <th scope="col" className="whitespace-nowrap px-3 py-3.5 text-left text-sm font-semibold capitalize text-black">
                    Related Entity
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold capitalize text-black">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <Loader />
                ): data && data.length > 0 ? (
                data?.map((data, index) => (
                  <tr key={data.id} className="border-b border-b-primaryGray cursor-pointer" onClick={() => onRowClick(data.id)}>
                    <td className="px-3 text-xs text-black capitalize font-medium">{index + 1}</td>
                    <td className="whitespace-nowrap px-3 py-4 text-xs text-[#0A0A0A] font-semibold flex items-center capitalize">{data?.reference}</td>
                    <td className="whitespace-nowrap px-3 text-xs text-[#0A0A0A]/80 capitalize font-medium text-center">{formatDateTime(data?.date)}</td>
                    <td className="whitespace-nowrap px-3 text-xs text-[#0A0A0A]/80 capitalize font-medium">{data.type}</td>
                    <td
                      className={`whitespace-nowrap px-3 text-xs capitalize font-bold ${
                        data?.amount >= 0 ? "text-green-500 font-bold" : "text-red-500 font-bold"
                      }`}
                    >
                      {data?.amount >= 0 
                        ? `+ ₦${Math.abs(data?.amount)}`
                        : `- ₦${Math.abs(data?.amount)}`}
                    </td>

                    <td className="text-xs capitalize font-semibold my-2 px-2 text-center">{FormatePrice(data?.balance)}</td>
                    <td className={`text-sm lg:text-md capitalize font-semibold text-center rounded-m inline-block w-[110px] whitespace-nowrap px-3 py-2 my-2 rounded-md cursor-pointer
                       ${
                      TransactionStatus[data?.paymentStatus] === 'Success'
                      ? 'bg-[#D9ECD9] text-[#008000]'
                      : TransactionStatus[data?.paymentStatus] === 'Pending'
                      ? 'bg-[#FFF6E6] text-orange'
                      : TransactionStatus[data?.paymentStatus] ==="Failed"
                      ? 'bg-[#FFE6E6] text-primaryRed'
                      : "bg-primaryGray text-black"
                      }   
                    `}>
                      {TransactionStatus[data?.paymentStatus]}</td>
                    <td className="px-3 whitespace-nowrap text-center text-xs capitalize font-semibold">{data?.orderCode}</td>
                    <td className="whitespace-nowrap px-3 py-2 text-lg text-[#B3B3B3] flex items-center justify-center">{<IoIosMore />}</td>
                  </tr>
                 )))
                 : (
                   <p className="text-primaryRed py-3 text-md">No Transiaction History to display</p>
                 )
                 }
              </tbody>
            </table>
            <nav className="grid place-items-center mt-10">
            <ResponsivePagination
              current={currentPage}
              total={totalPages}
              onPageChange={setCurrentPage}
              extraClassName="custom-pagination"
            />
            </nav>
          </div>
        </div>
    </div>
  )
}

export default TransactionsTable